/* TypeScript file generated from Stack.resi by genType. */

/* eslint-disable */
/* tslint:disable */

import * as StackJS from './Stack.res.js';

import type {t as Spaces_t} from '../../../src/resources/theme/Spaces.gen';

export type align = 
    "center"
  | "end"
  | "start"
  | "spaceBetween"
  | "stretch";

export type props<children,space,align> = {
  readonly children: children; 
  readonly space?: space; 
  readonly align?: align
};

export const make: React.ComponentType<{
  readonly children: React.ReactNode; 
  readonly space?: Spaces_t; 
  readonly align?: align
}> = StackJS.make as any;
